import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import CaseDetailArea from '../../../components/caseDetail'
import './style.scss'
const AllCasesDetailPage = () => {
    const [readMore, setReadMore] = React.useState(true);
    return (
        <Fragment>
            
           <CaseDetailArea
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default AllCasesDetailPage
/* DocsDestailArea */